import { TAGS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import tagsTypes from '../../constants/tagsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'


//
const get_tag_request = () => {
  return {
    type: tagsTypes.get.request
  }
}

const get_tag_success = (response) => {
  return {
    type: tagsTypes.get.success,
    payload: response.data.tag
  }
}

const get_tag_failure = (messages) => {
  return {
    type: tagsTypes.get.failure,
    payload: messages
  }
}

const get_tag = (tag_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_tag_request())

    // Request
    axios.get(
      formatRoute(TAGS_ROUTES.get, {id: tag_id})
    ).then( response => {
      // success

      dispatch( get_tag_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching tag."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_tag_failure(errors))
    })
  }

}

export {
  get_tag
}



// WEBPACK FOOTER //
// ./src/js/actions/tags/get.js